import React from 'react';
import clsx from "clsx";
import {useTranslation} from "react-i18next";

export interface InfoProps {
  title: string;
  value?: string;
  copyValue?: string;
  copied?: boolean;
  onCopy?: (value: string) => void;
  children?: React.ReactNode;
}

export const Info = ({
                       title,
                       value,
                       copyValue,
                       copied,
                       onCopy,
                       children,
                     }: InfoProps) => {
  const {t} = useTranslation();
  return (
    <div className='mb-4'>
      <div className='fw-semibold text-gray-600 fs-7 d-flex align-items-center justify-content-between gap-2'>
        <span>{title}:</span>
        {copyValue && onCopy && (
          <button
            type='button'
            className='btn btn-sm btn-icon'
            onClick={() => onCopy(copyValue)}
            title={t('Copy')}
          >
            <i className='ki-duotone ki-copy fs-5'/>
          </button>
        )}
      </div>
      {value && (
        <div className='fw-bold text-gray-800 fs-6'>
          {value}
          {copied && <span className='text-success fw-semibold fs-8 ms-2'>{t('Copied')}</span>}
        </div>
      )}
      {children}
    </div>
  );
}


export interface TrxAmountInfoProps {
  direction: -1 | 1;
  trxamount: number|string;
  amount: number;
  currency: string;
  origin_amount?: number;
  origin_currency?: string;
}

export const TrxAmountInfo = ({
                                direction,
                                trxamount,
                                amount,
                                currency,
                                origin_amount,
                                origin_currency,
                              }: TrxAmountInfoProps) => {
  const {t} = useTranslation();
  return (
    <Info title={t('Amount')}>
      <div className='fw-bold fs-6 text-gray-800 d-flex align-items-center flex-wrap'>
        <span
          className={clsx('pe-2', {
            'text-danger': direction == -1,
            'text-success': direction == 1,
          })}
        >
          {`${direction == -1 ? '-' : '+'}${t(
            'intlCurrency',
            {
              value:
                trxamount || amount,
              currency: currency,
            }
          )}`}
          {origin_amount &&
            origin_currency !=
            currency && (
              <span className='fs-7 d-flex align-items-center text-gray-600'>
                {t('intlCurrency', {
                  value: origin_amount,
                  currency: origin_currency,
                })}
              </span>
            )}
        </span>
      </div>
    </Info>
  )
}


export function InfoRow({
                   label,
                   value,
                   mono = false,
                 }: {
  label: string;
  value: React.ReactNode;
  mono?: boolean;
}) {
  return (
    <div className='d-flex justify-content-between align-items-start py-2 border-bottom'>
      <span className='text-muted fs-7 me-4'>{label}</span>
      <span className={clsx('fw-semibold text-gray-800 text-end', mono && 'font-monospace')}>
        {value}
      </span>
    </div>
  );
}
